import { Facebook, Instagram, Youtube, ArrowUp } from "lucide-react";
import { NAV_LINKS, SOCIAL_LINKS, CONTACT_INFO } from "../data/siteData";

export const Footer = () => {
    return (
        <footer data-testid="footer" className="bg-[#0E0E10] text-white">
            <div className="cmyk-strip">
                <span className="c" /><span className="m" /><span className="y" /><span className="k" />
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
                <div className="grid lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-6">
                        <img src="/assets/logo-horizontal-white.png" alt="Studio Arti Grafiche" data-testid="footer-logo" className="h-12 sm:h-14 w-auto" />
                        <p className="mt-4 font-serif-accent italic text-zinc-400 max-w-sm">
                            Laboratorio di progettazione grafica e stampa a Gela, Sicilia.
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-social-facebook" aria-label="Facebook" className="p-2.5 border border-zinc-700 text-zinc-300 hover:border-[#FF0066] hover:text-[#FF0066] transition-colors duration-200">
                                <Facebook size={18} />
                            </a>
                            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-social-instagram" aria-label="Instagram" className="p-2.5 border border-zinc-700 text-zinc-300 hover:border-[#FF0066] hover:text-[#FF0066] transition-colors duration-200">
                                <Instagram size={18} />
                            </a>
                            <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noopener noreferrer" data-testid="footer-social-youtube" aria-label="YouTube" className="p-2.5 border border-zinc-700 text-zinc-300 hover:border-[#FF0066] hover:text-[#FF0066] transition-colors duration-200">
                                <Youtube size={18} />
                            </a>
                        </div>
                    </div>
                    <div className="lg:col-span-3">
                        <p className="font-mono-label text-xs text-zinc-500 mb-5">Navigazione</p>
                        <ul className="space-y-3">
                            {NAV_LINKS.map((link) => (
                                <li key={link.id}>
                                    <a href={`#${link.id}`} data-testid={`footer-link-${link.id}`} className="text-sm text-zinc-300 hover:text-[#FF0066] transition-colors duration-200">
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="lg:col-span-3">
                        <p className="font-mono-label text-xs text-zinc-500 mb-5">Contatti</p>
                        <ul className="space-y-3 text-sm text-zinc-300">
                            <li>{CONTACT_INFO.address}</li>
                            <li><a href={`tel:${CONTACT_INFO.phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors">{CONTACT_INFO.phone}</a></li>
                            <li><a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-white transition-colors">{CONTACT_INFO.email}</a></li>
                        </ul>
                    </div>
                </div>
                <div className="mt-14 pt-8 border-t border-zinc-800 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-zinc-500">
                        © {new Date().getFullYear()} Studio Arti Grafiche — Gela (CL). Tutti i diritti riservati.
                    </p>
                    <a
                        href="#home"
                        data-testid="footer-back-to-top"
                        className="inline-flex items-center gap-2 text-xs font-mono-label text-zinc-400 hover:text-[#FF0066] transition-colors duration-200"
                    >
                        Torna su <ArrowUp size={14} />
                    </a>
                </div>
            </div>
        </footer>
    );
};
